import React from 'react';
import styled from 'astroturf/react';
import { Grid, GridProps } from './Grid';
import _Container from "GridWrapper-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/grid/GridWrapper.tsx?styleId=Container";
import _NoPaddingGrid from "GridWrapper-NoPaddingGrid.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/grid/GridWrapper.tsx?styleId=NoPaddingGrid";
import _PaddingContainer from "GridWrapper-PaddingContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/grid/GridWrapper.tsx?styleId=PaddingContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const NoPaddingGrid = /*#__PURE__*/styled(Grid, null, {
  displayName: "NoPaddingGrid",
  styles: _NoPaddingGrid
});

const PaddingContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PaddingContainer",
  styles: _PaddingContainer
});

export type GridWrapperProps = GridProps & {
  leftPaddingStyle?: React.CSSProperties;
  rightPaddingStyle?: React.CSSProperties;
  containerClassName?: string;
};

/**
 * Same as Grid, but changes left and right padding to be elements instead.
 * These elements can be styled to match designs more easily, especially
 * when designing pages that have left or right background coloring.
 * @param leftPaddingStyle The left margin component's style
 * @param rightPaddingStyle The right margin component's style
 * @param containerClassName The class name to send to the container
 * @param children The children to render
 * @param gridProps The {@link Grid} props
 */
export const GridWrapper: React.FC<GridWrapperProps> = ({
  leftPaddingStyle,
  rightPaddingStyle,
  containerClassName,
  children,
  ...gridProps
}) => {
  return (
    <Container className={containerClassName}>
      <PaddingContainer style={leftPaddingStyle} />
      <NoPaddingGrid {...gridProps}>{children}</NoPaddingGrid>
      <PaddingContainer style={rightPaddingStyle} />
    </Container>
  );
};
